var _path, _path2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProfile3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 264 264",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m264.13 132c0 72.974-59.157 132.13-132.13 132.13-72.975 0-132.13-59.16-132.13-132.13 0-72.973 59.157-132.13 132.13-132.13 72.976 0 132.13 59.159 132.13 132.13z",
    fill: "#FAED26"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "a",
    x: -1,
    y: -1,
    width: 266,
    height: 265,
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m-0.12 131.74c0 72.976 59.157 132.13 132.13 132.13 72.975 0 132.14-59.157 132.14-132.13 0-72.975-59.16-132.13-132.14-132.13-72.975 0-132.13 59.157-132.13 132.13z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m197.23 105.63c0 48.243 11.293 89.124-69.403 89.124-78.944 0-64.272-40.881-64.272-89.124 0-48.241 24.071-71.77 67.64-71.77 43.573 0 66.035 23.529 66.035 71.77z",
    fill: "#332114"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m154 158.3c13.889-7.154 24.782-20.58 29.882-36.133 0.744 0.289 1.519 0.456 2.322 0.456 5.149 0 9.322-6.26 9.322-13.983 0-7.577-4.021-13.732-9.034-13.962-3.802-27.553-26.854-48.749-54.739-48.749-27.933 0-51.017 21.273-54.755 48.901-0.4533-0.1027-0.916-0.172-1.388-0.172-5.1493 0-9.3227 6.2604-9.3227 13.982 0 7.723 4.1734 13.983 9.3227 13.983 1.3467 0 2.6227-0.436 3.78-1.207 4.9413 15.71 15.787 29.334 29.694 36.662v21.518c-26.26 3.662-12.64 8.56-12.64 8.56s3.2307 17.955 32.044 17.955c28.814 0 54.145-21.952 25.512-26.347v-21.464z",
    fill: "#FFC78C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m171.33 185.03c-17.935 0-11.064 14.654-37.922 14.654-0.484 0-0.933-0.014-1.396-0.022-0.461 8e-3 -0.91 0.022-1.394 0.022-26.858 0-19.987-14.654-37.922-14.654-25.785 0-52.643 82.733-34.531 82.733h147.69c18.112 0-8.743-82.733-34.529-82.733z",
    fill: "#62466F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m157.96 181.57c-4.52 4.52-11.474 12.79-25.948 13.308-14.472-0.518-21.426-8.788-25.947-13.308-4.667-4.667-17.721 1.584-15.356 3.638 2.3347 2.028 21.716 19.836 41.303 20.239 19.588-0.403 38.269-18.312 40.606-20.341 2.366-2.054-9.992-8.203-14.658-3.536z",
    fill: "#FEFBFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m67.861 94.478s11.808 2.4134 35.686 3.6174c0.986-11.42 2.952-16.199 2.952-16.199s9.143 16.869 15.176 16.869c42.603 0 70.767-4.288 70.767-4.288s-9.157-51.708-63.148-51.708c-53.993 0-61.433 51.708-61.433 51.708z",
    fill: "#332114"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 264,
    height: 264,
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile3);
export default __webpack_public_path__ + "static/media/profile-3.fee762dcf3259ce085d1e0bbee3c477b.svg";
export { ForwardRef as ReactComponent };